/**
 * Formata o corpo da mensagem:
 * 1. Escapa HTML para segurança contra XSS.
 * 2. Transforma URLs em links clicáveis.
 * 3. Transforma *texto* em <strong>texto</strong>.
 */
export default function formatMessage(body) {
  if (!body) return "";

  // 1. Escapar HTML para evitar XSS (já que usamos v-html)
  let escaped = body
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");

  // 2. Linkify: Transforma URLs em links <a>
  // Regex para capturar URLs (http, https, ftp)
  const urlRegex = /((?:https?|ftp):\/\/[^\s<]+[^<.,:;"')\]\s])/g;
  let formatted = escaped.replace(urlRegex, (url) => {
    return `<a href="${url}" target="_blank" rel="noopener noreferrer" style="color: inherit; text-decoration: underline;">${url}</a>`;
  });

  // 3. Bold: Transforma *texto* em <strong>texto</strong>
  formatted = formatted.replace(/\*(.*?)\*/g, "<strong>$1</strong>");

  return formatted;
}
